<label class="switch">
  <input type="checkbox" {{#if context}}checked{{/if}}>
  <div class="slider"></div>
  <span>{{#if config.label}} {{ config.label }}{{/if}}</span>
</label>
{{#if config.comment}}<span class="comment">{{ config.comment }}</span>{{/if}}
